import React from "react";

const Mail = () => (
  <svg className="mail-icon" x="0px" y="0px" viewBox="0 0 64 41.9">
    <g>
      <path
        className="cls-1"
        d="M63,0H1C0.4,0,0,0.4,0,1v40c0,0.6,0.4,1,1,1h62c0.6,0,1-0.4,1-1V1C64,0.4,63.6,0,63,0z M60.3,2L32,25.7L3.7,2H60.3z M2,40
			V3.1l30,25.2L62,3.1V40H2z"
      />
    </g>
  </svg>
);

export default Mail;
